import moment from "moment";
import { Typography } from "@mui/material";
import randomatic from "randomatic";
import DOMPurify from "dompurify";

import messages from "../assets/locale/messages";
import store from "../store";
import { showHideSnackbar } from "../store/Snackbar/actions";
import { LANGUAGES } from "./Constants";

export const showSuccessMsg = (msg, customMsg) => {
  const { lang } = store.getState().locale;
  const { successMsgs } = messages[lang];
  store.dispatch(
    showHideSnackbar({
      isOpen: true,
      type: "success",
      message: customMsg || successMsgs[msg]
    })
  );
};

export const showErrorMsg = (message) => {
  store.dispatch(
    showHideSnackbar({
      isOpen: true,
      type: "error",
      message
    })
  );
};

export const generateUniqueSrc = (src) => {
  const timestamp = new Date().getTime();
  return `${src}?v=${timestamp}`;
};

export const getNamesInitials = (fullName) => {
  return fullName
    ? fullName
        .split(" ")
        .filter((_, i) => i < 2)
        .map((name) => name[0]?.toUpperCase())
        .join("")
    : "";
};

export const formatDate = (
  date,
  row,
  format,
  stringInterpolation
) => {
  return date ? (
    stringInterpolation ? (
      moment(date)
        .locale("en")
        .format(format || "D MMM, YYYY")
    ) : (
      <div className={`${row && "d-flex gap-2"}`}>
        <p className="mb-0">
          {moment(date)
            .locale("en")
            .format(format || "D MMM, YYYY")}
        </p>
      </div>
    )
  ) : (
    "__"
  );
};

export const checkForMultiline = (text, specialFormatting = "") => {
  const { lang } = store.getState().locale;
  if (!text || (text && typeof text === "string" && !text.trim())) {
    return null;
  }

  let multiLineArray = [];
  multiLineArray = `${text}`.split("\n");
  if (multiLineArray.length > 1) {
    return multiLineArray.map((line) => {
      return (
        <Typography
          key={line}
          variant="body2"
          sx={{ flexGrow: 1 }}
          className={`brand-data mt-2  ${
            specialFormatting
              ? ""
              : lang === LANGUAGES.en
                ? "me-5"
                : "ms-5"
          } m-md-0 ${specialFormatting ?? ""}`}>
          {line}
        </Typography>
      );
    });
  } else {
    return text;
  }
};

export const checkBackgroundImageValidity = (url, callback) => {
  const img = new Image();
  img.onload = function () {
    // Image loaded successfully
    callback(true);
  };
  img.onerror = function () {
    // Image failed to load
    callback(false);
  };
  img.src = url;
};

export const areAllParamsEmpty = (paramsObj) => {
  let isEmpty = true;
  Object.keys(paramsObj).forEach((key) => {
    if (paramsObj[key] != null && !!paramsObj[key]?.length) {
      isEmpty = false;
    }
  });
  return isEmpty;
};

export const RandomCodeGenerator = ({ pattern, length, options }) => {
  let allChars = "";
  if (pattern) {
    allChars = randomatic(pattern || "*", length, options);
  } else {
    const upper = randomatic("A", 1);
    const lower = randomatic("a", 1);
    const digit = randomatic("0", 1);
    const remaining = randomatic("Aa0", length - 3);
    allChars = upper + lower + digit + remaining;
    allChars = allChars
      .split("")
      .sort(() => 0.5 - Math.random())
      .join("");
  }
  return allChars;
};

export const RichTextToHTML = (richText) => {
  // Ensure that the rich text content is properly sanitized
  const sanitizedHTML = DOMPurify.sanitize(richText, {
    USE_PROFILES: { html: true }
  });

  return { __html: sanitizedHTML };
};

export const isRichText = (text) => {
  const htmlRegex = /<\/?[a-z][\s\S]*>/i;
  return htmlRegex.test(text);
};
